// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/growth_home.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3 } from "@bufbuild/protobuf";
import { EntityRef, PursuitLabel } from "./pursuit_read_pb";
/**
 * Identity and permitted scope come exclusively from the gateway principal.
 *
 * @generated from message mono.projectdata.v1.GetGrowthHomeWorkRequest
 */ export class GetGrowthHomeWorkRequest extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthHomeWorkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthHomeWorkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthHomeWorkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthHomeWorkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * my | team
   *
   * @generated from field: string lens = 1;
   */ _define_property(this, "lens", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthHomeWorkRequest, "runtime", proto3);
_define_property(GetGrowthHomeWorkRequest, "typeName", "mono.projectdata.v1.GetGrowthHomeWorkRequest");
_define_property(GetGrowthHomeWorkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "lens",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GrowthHomeWorkItem
 */ export class GrowthHomeWorkItem extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeWorkItem().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeWorkItem().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeWorkItem().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeWorkItem, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * pursuit | proposal | rfi
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string href = 4;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeWorkItem, "runtime", proto3);
_define_property(GrowthHomeWorkItem, "typeName", "mono.projectdata.v1.GrowthHomeWorkItem");
_define_property(GrowthHomeWorkItem, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GrowthHomeAttention
 */ export class GrowthHomeAttention extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeAttention().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeAttention().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeAttention().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeAttention, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * @generated from field: string date = 4;
   */ _define_property(this, "date", ""), /**
   * Due | Recorded | Checked (read time, never a source date)
   *
   * @generated from field: string date_label = 5;
   */ _define_property(this, "dateLabel", ""), /**
   * @generated from field: string explanation = 6;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string source = 7;
   */ _define_property(this, "source", ""), /**
   * GRW-21 (v2): typed items. kind ∈ task | lifecycle | rfi_due | proposal_review | decision_due |
   * rfi_unowned | recompete_unpursued | black_hat_stale_sheet
   *
   * @generated from field: string kind = 8;
   */ _define_property(this, "kind", ""), /**
   * danger | warning | neutral
   *
   * @generated from field: string severity = 9;
   */ _define_property(this, "severity", ""), /**
   * "Due 6 Nov" | "Overdue 3 Nov" | "11 months" | "Changed"
   *
   * @generated from field: string badge_label = 10;
   */ _define_property(this, "badgeLabel", ""), /**
   * "Open" | "Review" | "Open a pursuit"
   *
   * @generated from field: string action_label = 11;
   */ _define_property(this, "actionLabel", ""), /**
   * @generated from field: string capture_project_id = 12;
   */ _define_property(this, "captureProjectId", ""), /**
   * recompete_unpursued only (OpenRecompetePursuit)
   *
   * @generated from field: string program_id = 13;
   */ _define_property(this, "programId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeAttention, "runtime", proto3);
_define_property(GrowthHomeAttention, "typeName", "mono.projectdata.v1.GrowthHomeAttention");
_define_property(GrowthHomeAttention, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "date",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "date_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "severity",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "badge_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "action_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "program_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GetGrowthHomeWorkResponse
 */ export class GetGrowthHomeWorkResponse extends Message {
    static fromBinary(bytes, options) {
        return new GetGrowthHomeWorkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GetGrowthHomeWorkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GetGrowthHomeWorkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GetGrowthHomeWorkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string as_of = 1;
   */ _define_property(this, "asOf", ""), /**
   * @generated from field: int32 pursuits = 2;
   */ _define_property(this, "pursuits", 0), /**
   * @generated from field: int32 proposals = 3;
   */ _define_property(this, "proposals", 0), /**
   * @generated from field: int32 rfis = 4;
   */ _define_property(this, "rfis", 0), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeWorkItem items = 5;
   */ _define_property(this, "items", []), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeAttention attention = 6;
   */ _define_property(this, "attention", []), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeChange changes = 7;
   */ _define_property(this, "changes", []), /**
   * Source adapter failures do not erase independently read active work.
   *
   * @generated from field: bool changes_unavailable = 8;
   */ _define_property(this, "changesUnavailable", false), /**
   * GRW-21 (v2). Additive: the flag-off page ignores them.
   *
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeKpi kpis = 9;
   */ _define_property(this, "kpis", []), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomePursuitRow pursuit_rows = 10;
   */ _define_property(this, "pursuitRows", []), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeThreadChange thread_changes = 11;
   */ _define_property(this, "threadChanges", []), /**
   * RFC3339 window start of thread_changes
   *
   * @generated from field: string changes_since = 12;
   */ _define_property(this, "changesSince", ""), /**
   * @generated from field: int32 parked_pursuits = 13;
   */ _define_property(this, "parkedPursuits", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GetGrowthHomeWorkResponse, "runtime", proto3);
_define_property(GetGrowthHomeWorkResponse, "typeName", "mono.projectdata.v1.GetGrowthHomeWorkResponse");
_define_property(GetGrowthHomeWorkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "as_of",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "pursuits",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "proposals",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "rfis",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "items",
            kind: "message",
            T: GrowthHomeWorkItem,
            repeated: true
        },
        {
            no: 6,
            name: "attention",
            kind: "message",
            T: GrowthHomeAttention,
            repeated: true
        },
        {
            no: 7,
            name: "changes",
            kind: "message",
            T: GrowthHomeChange,
            repeated: true
        },
        {
            no: 8,
            name: "changes_unavailable",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "kpis",
            kind: "message",
            T: GrowthHomeKpi,
            repeated: true
        },
        {
            no: 10,
            name: "pursuit_rows",
            kind: "message",
            T: GrowthHomePursuitRow,
            repeated: true
        },
        {
            no: 11,
            name: "thread_changes",
            kind: "message",
            T: GrowthHomeThreadChange,
            repeated: true
        },
        {
            no: 12,
            name: "changes_since",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 13,
            name: "parked_pursuits",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * One KPI tile (order: live_pursuits, rfi_due, decisions_due, proposals_in_flight).
 *
 * @generated from message mono.projectdata.v1.GrowthHomeKpi
 */ export class GrowthHomeKpi extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeKpi().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeKpi().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeKpi().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeKpi, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string key = 1;
   */ _define_property(this, "key", ""), /**
   * @generated from field: string label = 2;
   */ _define_property(this, "label", ""), /**
   * @generated from field: int32 value = 3;
   */ _define_property(this, "value", 0), /**
   * @generated from field: string note = 4;
   */ _define_property(this, "note", ""), /**
   * info | warning | danger | success
   *
   * @generated from field: string tone = 5;
   */ _define_property(this, "tone", ""), /**
   * @generated from field: string href = 6;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeKpi, "runtime", proto3);
_define_property(GrowthHomeKpi, "typeName", "mono.projectdata.v1.GrowthHomeKpi");
_define_property(GrowthHomeKpi, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "note",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "tone",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One "My pursuits" / "Team pursuits" row (live pursuits only, §3.1 rule L).
 *
 * @generated from message mono.projectdata.v1.GrowthHomePursuitRow
 */ export class GrowthHomePursuitRow extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomePursuitRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomePursuitRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomePursuitRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomePursuitRow, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string capture_project_id = 1;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string name = 2;
   */ _define_property(this, "name", ""), /**
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * @generated from field: string subtitle = 4;
   */ _define_property(this, "subtitle", ""), /**
   * @generated from field: mono.projectdata.v1.EntityRef customer = 5;
   */ _define_property(this, "customer", void 0), /**
   * @generated from field: repeated mono.projectdata.v1.PursuitLabel labels = 6;
   */ _define_property(this, "labels", []), /**
   * "Gate 2 · 3 Nov" | "RFI #2 due · 6 Nov" | "—"
   *
   * @generated from field: string next_label = 7;
   */ _define_property(this, "nextLabel", ""), /**
   * YYYY-MM-DD
   *
   * @generated from field: string next_at = 8;
   */ _define_property(this, "nextAt", ""), /**
   * @generated from field: string last_activity_label = 9;
   */ _define_property(this, "lastActivityLabel", ""), /**
   * RFC3339
   *
   * @generated from field: string last_activity_at = 10;
   */ _define_property(this, "lastActivityAt", ""), /**
   * @generated from field: int32 quiet_days = 11;
   */ _define_property(this, "quietDays", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomePursuitRow, "runtime", proto3);
_define_property(GrowthHomePursuitRow, "typeName", "mono.projectdata.v1.GrowthHomePursuitRow");
_define_property(GrowthHomePursuitRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "subtitle",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "customer",
            kind: "message",
            T: EntityRef
        },
        {
            no: 6,
            name: "labels",
            kind: "message",
            T: PursuitLabel,
            repeated: true
        },
        {
            no: 7,
            name: "next_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "next_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "last_activity_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "last_activity_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "quiet_days",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * One "Changed on your pursuits since …" entry from the pursuit thread.
 *
 * @generated from message mono.projectdata.v1.GrowthHomeThreadChange
 */ export class GrowthHomeThreadChange extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeThreadChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeThreadChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeThreadChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeThreadChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string capture_project_id = 2;
   */ _define_property(this, "captureProjectId", ""), /**
   * @generated from field: string pursuit_name = 3;
   */ _define_property(this, "pursuitName", ""), /**
   * @generated from field: string text = 4;
   */ _define_property(this, "text", ""), /**
   * RFC3339
   *
   * @generated from field: string occurred_at = 5;
   */ _define_property(this, "occurredAt", ""), /**
   * @generated from field: string href = 6;
   */ _define_property(this, "href", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeThreadChange, "runtime", proto3);
_define_property(GrowthHomeThreadChange, "typeName", "mono.projectdata.v1.GrowthHomeThreadChange");
_define_property(GrowthHomeThreadChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "capture_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "pursuit_name",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "text",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "occurred_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * GRW-21: identity comes from the principal; it stores only the caller's own visit.
 *
 * @generated from message mono.projectdata.v1.MarkGrowthHomeSeenRequest
 */ export class MarkGrowthHomeSeenRequest extends Message {
    static fromBinary(bytes, options) {
        return new MarkGrowthHomeSeenRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkGrowthHomeSeenRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkGrowthHomeSeenRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkGrowthHomeSeenRequest, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkGrowthHomeSeenRequest, "runtime", proto3);
_define_property(MarkGrowthHomeSeenRequest, "typeName", "mono.projectdata.v1.MarkGrowthHomeSeenRequest");
_define_property(MarkGrowthHomeSeenRequest, "fields", proto3.util.newFieldList(()=>[]));
/**
 * @generated from message mono.projectdata.v1.MarkGrowthHomeSeenResponse
 */ export class MarkGrowthHomeSeenResponse extends Message {
    static fromBinary(bytes, options) {
        return new MarkGrowthHomeSeenResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new MarkGrowthHomeSeenResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new MarkGrowthHomeSeenResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(MarkGrowthHomeSeenResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string seen_at = 1;
   */ _define_property(this, "seenAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(MarkGrowthHomeSeenResponse, "runtime", proto3);
_define_property(MarkGrowthHomeSeenResponse, "typeName", "mono.projectdata.v1.MarkGrowthHomeSeenResponse");
_define_property(MarkGrowthHomeSeenResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "seen_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * One immutable source event, grouped only over visible, lens-filtered contexts.
 *
 * @generated from message mono.projectdata.v1.GrowthHomeChange
 */ export class GrowthHomeChange extends Message {
    static fromBinary(bytes, options) {
        return new GrowthHomeChange().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthHomeChange().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthHomeChange().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthHomeChange, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string title = 2;
   */ _define_property(this, "title", ""), /**
   * @generated from field: string href = 3;
   */ _define_property(this, "href", ""), /**
   * @generated from field: string recorded_at = 4;
   */ _define_property(this, "recordedAt", ""), /**
   * @generated from field: string published_at = 5;
   */ _define_property(this, "publishedAt", ""), /**
   * @generated from field: string retrieved_at = 6;
   */ _define_property(this, "retrievedAt", ""), /**
   * @generated from field: string explanation = 7;
   */ _define_property(this, "explanation", ""), /**
   * @generated from field: string source = 8;
   */ _define_property(this, "source", ""), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthHomeWorkItem contexts = 9;
   */ _define_property(this, "contexts", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthHomeChange, "runtime", proto3);
_define_property(GrowthHomeChange, "typeName", "mono.projectdata.v1.GrowthHomeChange");
_define_property(GrowthHomeChange, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "recorded_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "published_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "retrieved_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "explanation",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "source",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 9,
            name: "contexts",
            kind: "message",
            T: GrowthHomeWorkItem,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListGrowthWorkspacesRequest
 */ export class ListGrowthWorkspacesRequest extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthWorkspacesRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthWorkspacesRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthWorkspacesRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthWorkspacesRequest, a, b);
    }
    constructor(data){
        super(), /**
   * rfi_response | proposal  (required)
   *
   * @generated from field: string kind = 1;
   */ _define_property(this, "kind", ""), /**
   * open | closed | all (default open)
   *
   * @generated from field: string status = 2;
   */ _define_property(this, "status", ""), /**
   * default 50, max 200
   *
   * @generated from field: int32 page_size = 3;
   */ _define_property(this, "pageSize", 0), /**
   * opaque offset token
   *
   * @generated from field: string page_token = 4;
   */ _define_property(this, "pageToken", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthWorkspacesRequest, "runtime", proto3);
_define_property(ListGrowthWorkspacesRequest, "typeName", "mono.projectdata.v1.ListGrowthWorkspacesRequest");
_define_property(ListGrowthWorkspacesRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "page_size",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.GrowthWorkspaceRow
 */ export class GrowthWorkspaceRow extends Message {
    static fromBinary(bytes, options) {
        return new GrowthWorkspaceRow().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new GrowthWorkspaceRow().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new GrowthWorkspaceRow().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(GrowthWorkspaceRow, a, b);
    }
    constructor(data){
        super(), /**
   * rfi: rfi_response_projects.id ; proposal: zou project id
   *
   * @generated from field: string id = 1;
   */ _define_property(this, "id", ""), /**
   * @generated from field: string zou_project_id = 2;
   */ _define_property(this, "zouProjectId", ""), /**
   * rfi_response | proposal
   *
   * @generated from field: string kind = 3;
   */ _define_property(this, "kind", ""), /**
   * @generated from field: string title = 4;
   */ _define_property(this, "title", ""), /**
   * rfi: draft|in_progress|submitted|closed (raw select) ; proposal: zou project status.
   * Open/closed bucketing for RFIs also uses rfi_submissions (a submitted RFI is closed).
   *
   * @generated from field: string status = 5;
   */ _define_property(this, "status", ""), /**
   * "Draft" | "In progress" | "Submitted" | "Closed" | "Active" | "Archived" | "Pre-award"
   *
   * @generated from field: string status_label = 6;
   */ _define_property(this, "statusLabel", ""), /**
   * rfi: response_due (YYYY-MM-DD) ; proposal: ""
   *
   * @generated from field: string due_at = 7;
   */ _define_property(this, "dueAt", ""), /**
   * linked readable pursuits only (never a count of hidden ones)
   *
   * @generated from field: repeated mono.projectdata.v1.EntityRef pursuits = 8;
   */ _define_property(this, "pursuits", []), /**
   * 20-growth.md §3.2
   *
   * @generated from field: string href = 9;
   */ _define_property(this, "href", ""), /**
   * RFC3339
   *
   * @generated from field: string updated_at = 10;
   */ _define_property(this, "updatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(GrowthWorkspaceRow, "runtime", proto3);
_define_property(GrowthWorkspaceRow, "typeName", "mono.projectdata.v1.GrowthWorkspaceRow");
_define_property(GrowthWorkspaceRow, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "zou_project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "kind",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "title",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "status_label",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "due_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "pursuits",
            kind: "message",
            T: EntityRef,
            repeated: true
        },
        {
            no: 9,
            name: "href",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ListGrowthWorkspacesResponse
 */ export class ListGrowthWorkspacesResponse extends Message {
    static fromBinary(bytes, options) {
        return new ListGrowthWorkspacesResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ListGrowthWorkspacesResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ListGrowthWorkspacesResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ListGrowthWorkspacesResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: repeated mono.projectdata.v1.GrowthWorkspaceRow rows = 1;
   */ _define_property(this, "rows", []), /**
   * @generated from field: string next_page_token = 2;
   */ _define_property(this, "nextPageToken", ""), /**
   * @generated from field: int32 open_count = 3;
   */ _define_property(this, "openCount", 0), /**
   * @generated from field: int32 closed_count = 4;
   */ _define_property(this, "closedCount", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ListGrowthWorkspacesResponse, "runtime", proto3);
_define_property(ListGrowthWorkspacesResponse, "typeName", "mono.projectdata.v1.ListGrowthWorkspacesResponse");
_define_property(ListGrowthWorkspacesResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "rows",
            kind: "message",
            T: GrowthWorkspaceRow,
            repeated: true
        },
        {
            no: 2,
            name: "next_page_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "open_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "closed_count",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
